<template>
  <v-container>
    <v-row class="text-center">
      <v-col class="mb-4">
        <h1 class="display-2 font-weight-bold mb-3">Reaction Test</h1>
      </v-col>
    </v-row>

    <v-col cols="12" md="12">
      <v-card
        class="d-flex align-center"
        height="400"
        color="blue"
        @click="onClick()"
        v-if="this.state == 0"
      >
        <div class="flex-grow-1 text-center">
          <p class="text-h2" style="color: #fff">Click To Start</p>
          <p class="text-h5" style="color: #fff">
            When the red box turns green, click as quickly as you can.
          </p>
        </div>
      </v-card>

      <v-card
        class="d-flex align-center"
        height="400"
        color="red"
        @click="onClick()"
        v-if="this.state == 1"
      >
        <div class="flex-grow-1 text-center">
          <p class="text-h2" style="color: #fff">Wait For Green</p>
        </div>
      </v-card>

      <v-card
        class="d-flex align-center"
        height="400"
        color="blue"
        @click="onClick()"
        v-if="this.state == 2"
      >
        <div class="flex-grow-1 text-center">
          <p class="text-h2" style="color: #fff">Too Soon!</p>
          <p class="text-h5" style="color: #fff">Click to try again.</p>
        </div>
      </v-card>

      <v-card
        class="d-flex align-center"
        height="400"
        color="green"
        @click="onClick()"
        v-if="this.state == 3"
      >
        <div class="flex-grow-1 text-center">
          <p class="text-h2" style="color: #fff">Click!</p>
        </div>
      </v-card>

      <v-card
        class="d-flex align-center"
        height="400"
        color="blue"
        @click="onClick()"
        v-if="this.state == 4"
      >
        <div class="flex-grow-1 text-center">
          <p class="text-h2" style="color: #fff">{{ this.duration }} ms</p>
          <p class="text-h5" style="color: #fff">Click to try again.</p>
        </div>
      </v-card>
    </v-col>
    <v-card outlined>
      <v-card-title class="display-1">About This Website</v-card-title>
      <v-card-text class="title text-left">
        &nbsp;&nbsp;&nbsp;&nbsp;This website is used to test your reaction time.
        When the test starts, there will be a red bar on top of this page and it
        will turn green after a random duration. You have to click as quickly as
        you can when the red bar turns green. Then it will show how quickly you
        react to the event.
      </v-card-text>
    </v-card>
    <v-col></v-col>
    <inner-link></inner-link>
  </v-container>
</template>

<script>
import InnerLink from "./InnerLink.vue";
export default {
  name: "ReactionTest",
  components: {
    InnerLink,
  },
  metaInfo: {
    title: "Reaction Test: Test Your Reaction Time", // set a title
    meta: [
      {
        // set meta
        name: "keywords",
        content:
          "reaction test, \
          reaction time, \
          human benchmark, \
          reaction speed test, \
          reflex test, \
          reaction, \
          reflex, \
          human reaction, \
          ",
      },
      {
        // set meta
        name: "description",
        content: "This website is used to test your reaction time.",
      },
    ],
    link: [
      {
        // set link
        rel: "asstes",
        href: "http://fpshelper.com/en/reaction/",
      },
    ],
  },
  data: () => ({
    state: 0,
    duration: 0,
    st: 0,
    tmer: null,
  }),
  methods: {
    setTmer: function () {
      this.tmer = setTimeout(
        () => {
          this.state = 3;
          this.st = Date.now();
        },
        Math.max(Math.random() * 2000),
        1000
      );
    },
    onClick: function () {
      if (this.state == 0) {
        this.state = 1;
        this.setTmer();
      } else if (this.state == 1) {
        clearTimeout(this.tmer);
        this.state = 2;
      } else if (this.state == 2) {
        this.state = 1;
        this.setTmer();
      } else if (this.state == 3) {
        this.state = 4;
        this.duration = Date.now() - this.st;
      } else {
        this.state = 1;
        this.setTmer();
      }
    },
  },
};
</script>
